if (!window.opCarousel) {
  class OpCarousel {
    pagBulletClass = "";
    currPagBulletClass = "";
    slideCount = 0;
    slidesPerView = "auto";
    swiperSpaceBetween = 0;
    swiperLoop = false;
    swiperCenteredSlides = false;
    breakpoints = undefined;
    initialSlide = 0;
    swiper;
    elementName = "default";

    createSwiperCarousel(name) {
      this.elementName = name;
      if (customElements.get(`op-carousel-${name}`)) {
        console.error(`Element with name 'op-carousel-${name}' already exists`);
        return;
      }
      customElements.define(
        `op-carousel-${name}`,
        class OpCarouselElement extends HTMLElement {
          connectedCallback() {}

          getSlidesPerView(max) {
            return Math.min(this.slideCount, max);
          }

          disconnectedCallback() {
            this.swiper?.destroy();
          }
        }
      );
      return this;
    }

    initSwiper() {
      if (!window.Swiper) {
        console.error("Swiper is not defined");
        return null;
      }
      if (!customElements.get(`op-carousel-${this.elementName}`)) {
        console.error(
          `Element with name 'op-carousel-${this.elementName}' not found`
        );
        return null;
      }

      const swiperConfig = {
        slidesPerView: this.slidesPerView,
        centeredSlides: this.swiperCenteredSlides,
        spaceBetween: this.swiperSpaceBetween,
        loop: this.swiperLoop,
        watchOverflow: true,
        initialSlide: this.initialSlide,
        navigation: {
          prevEl: `.op-carousel-${this.elementName}__button-prev`,
          nextEl: `.op-carousel-${this.elementName}__button-next`,
        },
        pagination: {
          el: `.op-carousel-${this.elementName}__swiper-pagination`,
          clickable: true,
          bulletClass: this.pagBulletClass,
          bulletActiveClass: this.currPagBulletClass,
        },
        on: {
          init: (swiper) => {
            swiper.el?.closest('op-carousel-' + this.elementName)?.toggleAttribute('data-loaded', true);
          }
        }
      };
      if (this.breakpoints) {
        swiperConfig.breakpoints = this.breakpoints
      }
      
      this.swiper = new window.Swiper(
        `.op-carousel-${this.elementName}__swiper`,
        swiperConfig
      );
      customElements.get(`op-carousel-${this.elementName}`).prototype.swiper =
        this.swiper;
      return this;
    }
  }

  window.opCarousel = OpCarousel;
}
